export default class Assets {
    // ICONS
    public static arrowBack = require(`../assets/icons/levelup-icon-arrow-back.svg`);
    public static arrowUp = require(`../assets/icons/levelup-icon-arrow-up.svg`);
    public static avatarGeneric = require(`../assets/icons/avatar-generic.svg`);
    public static avatarMan = require(`../assets/icons/avatar-man.svg`);
    public static avatarWoman = require(`../assets/icons/avatar-woman.svg`);
    public static backgroundDecoration = require(`../assets/icons/levelup-background-element.svg`);
    public static backgroundDecorationLight = require(`../assets/icons/levelup-background-element-light.svg`);
    public static bill = require(`../assets/icons/levelup-icon-invoice.svg`);
    public static budgetDocument = require(`../assets/icons/levelup-icon-budget-document.svg`);
    public static confirmationTick = require(`../assets/icons/levelup-icon-confirmation-tick.svg`);
    public static defaultAvatar = require(`../assets/icons/levelup_avatar_default.svg`);
    public static deliveryNote = require(`../assets/icons/levelup-icon-delivery-note.svg`);
    public static iconExpense = require(`../assets/icons/levelup_icon_expense.svg`);
    public static iconIncome = require(`../assets/icons/levelup-icon-income.svg`);
    public static iconInvestment = require(`../assets/icons/levelup_icon_investment.svg`);
    public static iconSemiCircle = require(`../assets/icons/levelup-products-circle.svg`);
    public static levelUpCircle = require(`../assets/icons/levelup_circle.svg`);
    public static levelUpLogo = require(`../assets/icons/levelup-logo.svg`);
    public static levelUpLogoBlue = require(`../assets/icons/levelup-logo-blue.svg`);
    public static levelupLogoAccestance = require(`../assets/icons/levelup-logo-accestance.svg`);
    public static levelupLogoAccestanceDark = require(`../assets/icons/levelup-logo-accestance-dark.svg`);
    public static levelUpLogoLetras = require(`../assets/icons/logo-levelup-letras.svg`);
    public static logoutIcon = require(`../assets/icons/levelup-logout.svg`);
    public static logoutIconBlack = require(`../assets/icons/levelup-logout-black.svg`);
    public static mobileSign = require(`../assets/icons/icon-mobile-sign.svg`);
    public static modalClose = require(`../assets/icons/levelup_icon_cross.svg`);
    public static oIcon = require(`../assets/icons/levelup-icon-o.svg`);
    public static productCourses = require(`../assets/icons/levelup-products-courses.svg`);
    public static topShape = require(`../assets/icons/levelup-top-shape.svg`);
    public static xIcon = require(`../assets/icons/levelup-icon-x.svg`);
    public static xIconDeny = require(`../assets/icons/levelup-icon-x-deny.svg`);
    public static IconCloseSquared = require(`../assets/icons/icon-close-squared.svg`);
    public static IconCheckSquared = require(`../assets/icons/icon-check-squared.svg`);
    public static IconExcel = require(`../assets/icons/excel.svg`);

    // GIFS
    public static spinnerWhite = require(`../assets/gifs/spinner_white.gif`);
    public static spinnerGrey = require(`../assets/gifs/spinner_grey.gif`);

    // IMAGES
    public static countDownBg = require(`../assets/images/checkinapp-background.svg`);
    public static navbarBg = require(`../assets/images/navbar_background.svg`);
    public static navbarBgTest = require(`../assets/images/navbar_background_test.svg`);
    public static navbarAcceptanceBg = require(`../assets/images/nav-var-acceptance.png`);
    public static squaredBgCircle = require(`../assets/images/bgCircle.svg`);
    public static circleBlueGreen = require(`../assets/images/levelup-circle.svg`);
    public static sepaPreview = require(`../assets/images/sepa-preview.png`);
    public static acceptanceInfoBg = require(`../assets/images/acceptance-info-bg.png`);
    public static logoTlpe = require(`../assets/images/logo-levelup.png`);
    public static whatsappImg = require(`../assets/images/whatsapp-logo.png`);

    // App brand
    public static clickbuyLogo = require(`../assets/images/clickandbuy-logo.svg`);
    public static managerLogo = require(`../assets/images/levelup-manager.svg`);
    
    //Zip codes json
    public static zipCodesJson = require(`../assets/media/zipcodes.es.json`);

}
